<template>
<div>
    <HeaderContent header="ตั้งค่าเว็บไซต์" :img_header="header_image" link_back="content" />
    <MenuContentSetting />
    <ContentPaymentList />
</div>
</template>

<script>
import HeaderImage from '@/assets/settings.png'
import HeaderContent from '@/components/menuadmin/content/contentheader/HeaderContent.vue'
import MenuContentSetting from '@/components/menuadmin/content/contentsetting/MenuContentSetting.vue'
import ContentPaymentList from '@/components/menuadmin/content/contentsetting/ContentPaymentList.vue'

export default {
    name: 'contentPayment',
    components: {
        HeaderContent,
        MenuContentSetting,
        ContentPaymentList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>
